export var componentsLocales = {
  chooseFile: 'Выберите файл',
  choosedFile: 'Выбран файл',
  orDragHere: 'или перетащите сюда',
  requestErrorText: 'Файл не удалось загрузить на сервер, повторите попытку позже',
  errors: ['ошибка', 'ошибки', 'ошибок'],
  warnings: ['предупреждение', 'предупреждения', 'предупреждений']
};